module.exports = {"621024100":"西华池镇","621024101":"老城镇","621024102":"太白镇","621024103":"板桥镇","621024104":"何家畔镇","621024200":"吉岘乡","621024201":"肖咀乡","621024202":"段家集乡","621024203":"固城乡","621024204":"太莪乡","621024205":"店子乡","621024208":"蒿咀铺乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/621024.json
// module id = 2943
// module chunks = 0